import React from 'react';
import { X } from 'lucide-react';

const SizeChartModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      
      <div className="relative bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center">
          <h2 className="text-xl font-bold">Size Guide - Oversized Fit</h2>
          <button 
            onClick={onClose}
            className="hover:bg-gray-100 p-2 rounded-full transition-colors"
            aria-label="Close size guide"
          >
            <X size={24} />
          </button>
        </div>

        <div className="p-6">
          <div className="bg-orange-50 border border-orange-200 p-4 rounded-lg mb-6">
            <p className="font-bold text-orange-900">⚠️ Important Sizing Note</p>
            <p className="text-sm text-orange-700 mt-1">
              These shirts run smaller than standard US sizing. We strongly recommend ordering one size up from your usual size.
            </p>
          </div>

          <h3 className="font-bold mb-3">Available Sizes</h3>
          <table className="w-full border-collapse mb-6">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-3 text-left">Size</th>
                <th className="border p-3 text-left">Chest Width (inches)</th>
                <th className="border p-3 text-left">Recommended For</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-3 font-bold">M</td>
                <td className="border p-3">44"</td>
                <td className="border p-3 text-sm text-gray-600">Usually wears S or slim M</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border p-3 font-bold">L</td>
                <td className="border p-3">46"</td>
                <td className="border p-3 text-sm text-gray-600">Usually wears M or slim L</td>
              </tr>
              <tr>
                <td className="border p-3 font-bold">XL</td>
                <td className="border p-3">48"</td>
                <td className="border p-3 text-sm text-gray-600">Usually wears L or slim XL</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border p-3 font-bold">2XL</td>
                <td className="border p-3">50"</td>
                <td className="border p-3 text-sm text-gray-600">Usually wears XL or slim 2XL</td>
              </tr>
            </tbody>
          </table>

          <div className="bg-blue-50 p-4 rounded-lg mb-6">
            <h3 className="font-bold mb-2">Product Features</h3>
            <ul className="text-sm space-y-1">
              <li>• <strong>Oversized fit:</strong> Designed for a relaxed, comfortable style</li>
              <li>• <strong>Drop shoulder:</strong> Casual, modern silhouette</li>
              <li>• <strong>100% Terry Cotton:</strong> Soft, durable, and breathable</li>
              <li>• <strong>Unisex sizing:</strong> Suitable for all body types</li>
            </ul>
          </div>

          <div className="border-t pt-4">
            <h3 className="font-bold mb-2">How to Measure</h3>
            <div className="space-y-2 text-sm">
              <p>
                <strong>Chest Width:</strong> Measure around the fullest part of your chest, keeping the tape measure horizontal and snug but not tight.
              </p>
              <p>
                <strong>For best fit:</strong> Compare your measurement to the size chart above. If you're between sizes or prefer a more relaxed fit, size up.
              </p>
              <p className="text-gray-600 italic">
                Note: These measurements are for the garment laid flat. The oversized design provides extra room for comfort.
              </p>
            </div>
          </div>

          <div className="mt-6 p-4 bg-gray-100 rounded-lg">
            <p className="text-sm text-center text-gray-700">
              <strong>Need help choosing?</strong> Feel free to contact us at support@sfr.org for personalized sizing advice.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeChartModal;